<template>
    <div class="home">
        <div class="date_op">
            <DatePicker type="date" :placeholder="$t('select')+$t('date')" style="width: 200px"></DatePicker>
            ---
            <DatePicker type="date" :placeholder="$t('select')+$t('date')" style="width: 200px"></DatePicker>
            <Button type="primary">切换</Button>
        </div>
        <div class="detail">
            <div class="register item box_shadow">
                <div class="num">{{user}}</div>
                <div class="tit">注册数</div>
            </div>
            <div class="order item box_shadow">
                <div class="num">{{order}}</div>
                <div class="tit">订单数</div>
            </div>
            <div class="loan item box_shadow">
                <div class="num">{{order_success}}</div>
                <div class="tit">放款数</div>
            </div>
        </div>
        <Button type="primary" @click="getStatistics" style="margin-top: 16px;">刷新统计数据</Button>
        <div ref="chartRef" class="chart-wrap"></div>
    </div>
</template>
<script>
import echarts from 'echarts';

export default {
    data() {
        return {
            order: 0,
            order_success: 0,
            user: 0,
            chartInstance: null
        };
    },
    mounted() {
        this.loadData();
        this.getStatistics();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        if (this.chartInstance) this.chartInstance.dispose();
    },
    methods: {
        handleResize() {
            this.chartInstance && this.chartInstance.resize();
        },
        loadData() {
            this.$get(this.$path.home, {}).then(res => {
                if (res.data) {
                    this.order = res.data.order.count;
                    this.order_success = res.data.order_success.count;
                    this.user = res.data.user.count;
                } else {
                    this.$Message.error('获取数据失败');
                }
            });
        },
        getStatistics() {
            this.$get(this.$path.statistics, {}).then(res => {
                const list = Array.isArray(res.data) ? res.data : [];
                this.renderChart(list);
            }).catch(() => {
                this.renderChart([]);
            });
        },
        renderChart(list) {
            if (!this.$refs.chartRef) return;
            if (!this.chartInstance) {
                this.chartInstance = echarts.init(this.$refs.chartRef);
            }
            const names = list.map(item => item.agent_name || '');
            const option = {
                title: { text: '代理统计', left: 'center' },
                tooltip: { trigger: 'axis' },
                legend: {
                    data: ['充值金额', '提现金额', '用户数'],
                    top: 28
                },
                grid: { left: '3%', right: '4%', bottom: '3%', top: 60, containLabel: true },
                xAxis: { type: 'category', data: names, axisLabel: { rotate: names.length > 6 ? 30 : 0 } },
                yAxis: { type: 'value' },
                series: [
                    { name: '充值金额', type: 'bar', data: list.map(item => Number(item.chargeAmount) || 0), itemStyle: { color: '#6493FF' } },
                    { name: '提现金额', type: 'bar', data: list.map(item => Number(item.withdrawAmount) || 0), itemStyle: { color: '#F3674E' } },
                    { name: '用户数', type: 'bar', data: list.map(item => Number(item.userCount) || 0), itemStyle: { color: '#FEB915' } }
                ]
            };
            this.chartInstance.setOption(option, true);
        }
    }
};
</script>
<style lang="scss" scoped>
.home {
    .chart-wrap {
        width: 100%;
        height: 360px;
        margin-top: 16px;
    }
    .detail {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        .item{
            width: 200px;
            height: 100px;
            border-radius: 6px;
            color: #ffffff;
            padding: 15px;
            margin-right: 20px;
            .num{
                height: 40px;
                line-height: 40px;
                font-size: 20px;
                text-align: center;
            }
            .tit{
                height: 20px;
                line-height: 20px;
                text-align: center;
            }
        }
        .register{
            background-image: linear-gradient(to bottom,#F9A87A,#F3674E);
        }
        .order{
            background-image: linear-gradient(to bottom,#FCD650,#FEB915);
        }
        .loan{
            background-image: linear-gradient(to bottom,#88B3FA,#6493FF);
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/home/home.vue